import { createAction, props } from '@ngrx/store';
import { ErrorModel, Profile, UserInfo } from '@tekman/onmat/models';

export const auth = createAction('[ AUTHORIZATION_SERVICE] auth action');
export const authSuccess = createAction('[ AUTHORIZATION_SERVICE] AuthSuccess');
export const authFailure = createAction('[ AUTHORIZATION_SERVICE] AuthFailure', props<{ error: ErrorModel }>());

export const loadProfile = createAction('[Profile AUTHENTICATION_SERVICE] loadProfile', props<{ authProfile: any }>());
export const loadProfileSuccess = createAction('[Profile/API] Load Profile Success', props<{ profile: Profile; userInfo: UserInfo }>());
export const loadProfileFailure = createAction('[Profile/API] Load Profile Failure', props<{ error: ErrorModel }>());

export const pageNotFound = createAction('[ERROR NOT FOUND COMPONENT] Not Found', props<{ error: ErrorModel }>());

export const removeProfile = createAction('[Profile REMOVE] Remove Profile');
